import { render, staticRenderFns } from "./RecommendBanner.vue?vue&type=template&id=116c4a57&scoped=true&"
import script from "./RecommendBanner.vue?vue&type=script&lang=ts&"
export * from "./RecommendBanner.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendBanner.vue?vue&type=style&index=0&id=116c4a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116c4a57",
  null
  
)

export default component.exports